import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { getPopulateFSExportLedgerDataApiHandler } from "../../WorkSpace/Components/ApiServices/apiHandler";
import arrowLeftGreen from "../../assets/arrowLeftGreen.svg";
import { Navbar } from "../../Components/Navbar";
import { Submit } from "../../Components/Button";
import PreviewCard from "../../Components/populateFs/PreviewCard";
import "./preview.css";
//import ExportExcel from "../../Components/excelExport/ExportExcel";
import { getFS, saveCOA } from "../../services/api/StandAlone/preview";
import swal from "sweetalert";
import DisclosureCreateModal from "../../Components/Common/Moadel/DisclosureCreateModal";
import Loading from "../../Components/Common/Loader/Loading";
import SuccessPopup from "../../myfin_v2/elements/SuccessPopup";
import ErrorPopup from "../../myfin_v2/elements/ErrorPopup";

import Sidebar from "../../myfin_v2/elements/Sidebar"
import commoncss from "../../myfin_v2/css/common.module.css"
import fscss from "../../myfin_v2/css/fs.module.css"
import { Button } from "../../myfin_v2/elements/Button";
import buttoncss from "../../myfin_v2/css/button.module.css"
import { ReactComponent as FilterIcon } from "../../myfin_v2/assets/icons/filter.svg";
import { ReactComponent as LeftIcon } from "../../myfin_v2/assets/icons/left_arrow.svg";
import { ReactComponent as ExportIcon } from "../../myfin_v2/assets/icons/download.svg";

import COAModal from "../../myfin_v2/components/bookclosure/COAModal"
import Breadcrumb from "../../myfin_v2/components/Breadcrumb";

const Preview = () => {
  const user = JSON.parse(localStorage.getItem('user'));
  const history = useHistory();

  const [successPopup, setSuccessPopup] = useState({ isOpen: false, message: "" });
  const [errorPopup, setErrorPopup] = useState({ isOpen: false, message: "" });
  const [classification, setClassification] = useState({
    loading: false,
    isSuccess: false,
    response: [],
    error_message: null
  });
  const [projectName, setProjectName] = useState('')
  const [open, setOpen] = useState(false);
  const [loader, setLoader] = useState(false);
  const [saveCOAModal, setSaveCOAModal] = useState(false);


  const classification_fs = Object.keys(classification.response);

  const project_id = sessionStorage.getItem("project_id") || localStorage.getItem("project_id");
  const tb_id = sessionStorage.getItem("tb_id") || localStorage.getItem("tb_id");

  const sessProjectId = sessionStorage.getItem("adj_project_id");
  const isMatchingProject = !sessProjectId || sessProjectId === project_id;

  const workspaceName = (isMatchingProject ? sessionStorage.getItem("adj_workspace_name") : "") || localStorage.getItem("workspaceName") || "Workspace";
  const standaloneName = projectName || (isMatchingProject ? sessionStorage.getItem("adj_standalone_name") : "") || "";
  const workspaceID = (isMatchingProject ? sessionStorage.getItem("adj_workspace_id") : "") || localStorage.getItem("standalone_workspace_id") || localStorage.getItem("ws_id") || "";
  const standaloneTargetLink = project_id ? `/templateV2/${project_id}` : (workspaceID ? `/financialstatement/${workspaceID}` : "/myfinV2/standalonefs");
  const handleExport = async () => {
  try {
    const response = await getPopulateFSExportLedgerDataApiHandler(project_id);

    const blob = new Blob([response.data]);
    const url = window.URL.createObjectURL(blob);

    const link = document.createElement("a");
    link.href = url;
    link.download = "LedgerData.xlsx"; 
    document.body.appendChild(link);
    link.click();

    link.remove();
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error("Export failed:", error);
    setErrorPopup({ isOpen: true, message: "Failed to export ledger data" });
  }
};
  const breadcrumbItems = [
    {
      label: workspaceName,
      link: workspaceID ? `/financialstatement/${workspaceID}` : `/templateV2/${project_id}`,
      className: `${commoncss.nav_cnt_color} clickable`,
    },
    {
      label: standaloneName,
      link: standaloneTargetLink,
      className: `${commoncss.nav_cnt_color} clickable`,
    },
    { label: "Classification Preview", link: "", className: "headerLable" },
  ];

  useEffect(() => {
    (async () => {
      await fetchFsClassification();
    })()
  }, []);

  const fetchFsClassification = async () => {
    if (!classification.isSuccess) {
      try {
        setClassification((res) => {
          return {
            ...res,
            loading: true
          }
        });
        const apiResponse = await getFS(project_id, tb_id);
        setClassification((res) => {
          return {
            ...res,
            loading: false,
            isSuccess: true,
            response: apiResponse?.data?.classification_list
          }
        })
        const pName = apiResponse.data?.project?.project_name;
        if (pName) {
          setProjectName(pName);
          sessionStorage.setItem("adj_standalone_name", pName);
          sessionStorage.setItem("adj_project_id", project_id);
        }
      } catch (error) {
        setClassification((res) => {
          return {
            ...res,
            loading: false,
            isSuccess: false,
            error_message: error.message
          }
        })
      }
    }
  }

  const SaveCOA = (name) => {
    setLoader(true);
    saveCOA(project_id, { name })
      .then(res => {
        setLoader(false);
        setSaveCOAModal(false);
        setSuccessPopup({ isOpen: true, message: res.data?.message || "Saved Successfully" });
      })
      .catch(err => {
        setLoader(false);
        setSaveCOAModal(false);
        setErrorPopup({ isOpen: true, message: err.response?.data?.error || "Error saving COA" });
      });
  }

  return (
    <>
      <div className={commoncss.pageLayout}>
        <Sidebar />
        <div className={`d-flex ${commoncss.pageContent}`}>
          <motion.div
            initial={{ x: 100, opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            exit={{ x: 0, opacity: 0 }}
            transition={{ duration: 0.5, ease: "easeInOut" }} className={commoncss.w100} style={{ maxHeight: "95vh", overflowY: "hidden" }} >

            <Breadcrumb
              addCls={`${commoncss.greyBg} mb-3 preview-breadcrumb`}
              items={breadcrumbItems}
              headerActions={
                <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
                 <Button
                    icon={<ExportIcon width={18} height={18} />}
                    btnColor={buttoncss.secondary}
                    class_={buttoncss.greyBg}
                    label={"Export"}
                    onClick={handleExport}
                  />

                  {/* <Button
                    btnColor={buttoncss.secondary}
                    class_={buttoncss.greyBg}
                    label={"Save COA"}
                    onClick={() => setSaveCOAModal(true)}
                  /> */}

                  <Button
                    btnColor={buttoncss.primary}
                    label={"Confirm Grouping"}
                    onClick={() => history.push("/myfinV2/standalonefs")}
                  />
                </div>
              }
            />
            <div>
              {classification.loading ?
                <Loading />
                : classification.error_message ? <div className="text-danger text-center" >{classification.error_message}</div> :
                  <div className={`grid ${fscss.grid1}`}>
                    {classification_fs.map((dat, ix) => {
                      return (
                        <PreviewCard name={dat} data={classification.response[dat]} key={ix} />
                      );
                    })}
                  </div>
              }
            </div>
          </motion.div>
        </div>
      </div >
        {saveCOAModal && (
          <COAModal
            setCreateCOAModal={setSaveCOAModal}
            SaveCOA={SaveCOA}
            saveLable="Save"

          />
        )}
        
        <SuccessPopup 
          isOpen={successPopup.isOpen} 
          message={successPopup.message} 
          onClose={() => setSuccessPopup({ isOpen: false, message: "" })} 
        />
        <ErrorPopup 
          isOpen={errorPopup.isOpen} 
          message={errorPopup.message} 
          onClose={() => setErrorPopup({ isOpen: false, message: "" })} 
        />
    </>
  );
};

export default Preview;
